export function fireElementChanged(params: any, eventBus: any) {
    return {
        args: [
            params.element("element")
        ],
        exec: (element: any) => {
            eventBus.fire("element.changed", { element: element });
        }
    };
}

fireElementChanged.$inject = ["cli._params", "eventBus"];
